import React from "react";
import './Status.scss'
const Status = ({ severity = "primary", children }) => {
    return(
        <div className={`Status Status--${severity} animate__animated animate__fadeInUp`}>
            {children}
        </div>
    )
}
export default Status;